import { render, staticRenderFns } from "./roleTempletList.vue?vue&type=template&id=acae90b4&scoped=true"
import script from "./roleTempletList.vue?vue&type=script&lang=js"
export * from "./roleTempletList.vue?vue&type=script&lang=js"
import style0 from "./roleTempletList.vue?vue&type=style&index=0&id=acae90b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acae90b4",
  null
  
)

export default component.exports